import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiCamera } = FiIcons;

const About = ({ pageHeading = false }) => {
  const Heading = pageHeading ? 'h1' : 'h2';

  return (
    <section className="py-24 bg-beige-light overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative"
          >
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&w=800&q=80"
                alt="Film director working with a camera during production"
                loading="lazy"
                className="rounded-3xl shadow-lg mt-12 grayscale hover:grayscale-0 transition-all duration-700"
              />
              <img
                src="https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=800&q=80"
                alt="Film crew collaborating on a cinematic set"
                loading="lazy"
                className="rounded-3xl shadow-lg grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-black rounded-full flex items-center justify-center text-white border-8 border-beige-light shadow-2xl">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-orange">20+</div>
                <div className="text-[10px] uppercase font-bold tracking-widest">Years</div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ delay: 0.1 }}
          >
            <span className="text-accent-orange font-bold tracking-widest uppercase text-[10px] italic">The Director</span>
            <Heading className="text-5xl font-serif font-bold text-black mt-4 mb-8 uppercase tracking-tight leading-tight">Kevin V. Tudor</Heading>
            <p className="text-lg text-black/70 mb-8 leading-relaxed font-serif italic">
              "Every frame is a heartbeat. Every shadow tells a secret. My mission is to tell stories that refuse to stay quiet."
            </p>
            <div className="space-y-6 mb-10">
              {[
                { icon: FiAward, title: 'Award Winning', text: 'Recognized at major international film festivals for direction and cinematography.' },
                { icon: FiCamera, title: 'Cinematic Vision', text: 'Pioneering unique visual styles across sci-fi, horror, and dramatic narratives.' }
              ].map((item, idx) => (
                <div key={item.title} className="flex gap-5">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-beige">
                    <SafeIcon icon={item.icon} className="w-6 h-6 text-black" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-black mb-1 uppercase tracking-tight">{item.title}</h3>
                    <p className="text-black/60 leading-relaxed text-sm">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/team"
                className="bg-black text-white px-8 py-4 rounded-full font-bold shadow-lg hover:bg-accent-orange transition-all uppercase tracking-widest text-[10px] inline-block"
              >
                The Team
              </Link>
              <Link 
                to="/shorts"
                className="bg-transparent border border-black/10 text-black px-8 py-4 rounded-full font-bold hover:bg-black hover:text-white transition-all uppercase tracking-widest text-[10px] inline-block"
              >
                Filmography
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;